<template>
  <v-container class="py-8">
    <h1 class="text-h4 mb-2">
      Administration
    </h1>
    <p>Manage support requests and the affiliate program.</p>
    <v-tabs
      show-arrows
      class="mb-6"
    >
      <v-tab to="/admin/support">
        Support messages
      </v-tab>
      <v-tab to="/admin/affiliates">
        Affiliate administration
      </v-tab>
    </v-tabs>
    <router-view />
  </v-container>
</template>
<script>
export default { name: 'AdminArea' }
</script>
